import i18n from "@/i18n";
import { AllowedOps, DataUITypes, OpsLookUp, QueryAdditionalOperatorSupport } from "@medapro-types/AdvancedSearch/components/QueryBuilder";

const { t } = i18n.global;

export function getTranslatedSelectionOpsList(type: DataUITypes, additionalOperatorSupport?: QueryAdditionalOperatorSupport) {
  return getOpsListForDataType(type, additionalOperatorSupport).map((x) => {
    return { id: x, name: t(`op.${x}`) };
  });
}

export function getOpsListForDataType(type: DataUITypes, additionalOperatorSupport?: QueryAdditionalOperatorSupport): Array<AllowedOps> {
  const result: Array<AllowedOps> = Array.from(DATA_VALUE_TYPE_LOOKUP_TABLE[type]);
  if (additionalOperatorSupport?.operatorMissingSync) result.push("missingSync");
  return result;
}

export function requiresOperatorValueInput(operator: AllowedOps | null): boolean {
  return !!operator && operator !== "missingSync";
}

export function requiresOperatorLanguageSelection(operator: AllowedOps | null): boolean {
  return !!operator && operator !== "missingSync";
}

const DATA_VALUE_TYPE_LOOKUP_TABLE: OpsLookUp = {
  alphanumeric: ["equals", "equalsNot", "contains", "containsNot", "startsWith", "startsWithNot", "endsWith", "endsWithNot"],
  date: ["equals", "equalsNot", "before", "after"],
  datetime: ["equals", "equalsNot", "before", "after"],
  numeric: ["equals", "equalsNot", "greater", "greaterOrEqual", "less", "lessOrEqual"],
  logical: ["equals", "equalsNot"],
  interval: [
    "includes",
    "includesNot",
    "lowerLimitEqual",
    "lowerLimitEqualNot",
    "lowerLimitLess",
    "lowerLimitLessOrEqual",
    "lowerLimitGreater",
    "lowerLimitGreaterOrEqual",
    "upperLimitEqual",
    "upperLimitEqualNot",
    "upperLimitLess",
    "upperLimitLessOrEqual",
    "upperLimitGreater",
    "upperLimitGreaterOrEqual"
  ],
  catalogNode: ["startsWith", "startsWithNot"],
  selectionList: ["equals", "equalsNot"],
  searchableList: ["equals", "equalsNot", "contains", "containsNot", "startsWith", "startsWithNot", "endsWith", "endsWithNot"],
  attributeGroup: ["startsWith", "startsWithNot"],
  preselectTree: [],
  preselectList: []
};
